export function clamp(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
}

/**
 * Orders strings by UTF-16 code unit: the same on every machine, unlike
 * `localeCompare`, whose order follows the locale and ICU version. Use it
 * wherever an order feeds a seeded shuffle or pick.
 */
export function compareCodeUnits(left: string, right: string): number {
    return left < right ? -1 : left > right ? 1 : 0;
}

/**
 * The default of an exhaustive switch over a closed set: it only compiles
 * when every member has a case, so a new one cannot be silently ignored.
 * Throws if reached anyway (a value from outside the type).
 */
export function assertNever(value: never, what = 'value'): never {
    throw new Error(`Unexpected ${what}: ${JSON.stringify(value)}`);
}
